export default __webpack_public_path__ + "static/media/alert-selected.7abe466e.svg";